import { HorizAlignment, IProfileFilter, ISearch, ISearchProfile, ISearchProvider, ISearchProviderField, ISearchRequestSubset, SearchProviderFieldType } from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import { SalesAreaSearch } from "../PA.UIM.MD/SalesAreaSearch";
import { UserGroupTypeSearch } from "./UserGroupTypeSearch";
import * as _ from "lodash"
import { SearchUtils } from "../PA.UIM.Core/SearchUtils";
import { PASearch } from "../PA.Core/PASearch";



const vUI_UserGroup_Search_Fields: {[id:string]: ISearchProviderField } =
    {
        WB_USRGRP_ID:         {type: SearchProviderFieldType.number, renderOptions: { columnName: 'User Group WB Id',  columnResourceName: 'colUsrGrpWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
        USRGRP_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'User Group Id',     columnResourceName: 'colUsrGrpId',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
        USRGRP_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'User Group Name',   columnResourceName: 'colUsrGrpName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
        WB_USRGRPM_ID:        {type: SearchProviderFieldType.number, renderOptions: { columnName: 'User Group Type WB Id',  columnResourceName: 'colUsrGrpMWBId',      alignment: HorizAlignment.Center}, domainOptions: { maxLength: 256,  search: UserGroupTypeSearch, profileId: "default", searchCondition: {}}},
        USRGRPM_NAME:         {type: SearchProviderFieldType.string, renderOptions: { columnName: 'User Group Type',   columnResourceName: 'colUsrGrpType',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},

        MDSET_NAME:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'MD Set',   columnResourceName: 'colUsrGrpMDset',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},

        SALESORG_NAME:         {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Sales Org',   columnResourceName: 'colUsrGrpSalesOrg',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
        WB_SALESAREA_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'User Group Type WB Id',  columnResourceName: 'colUsrGrpSARWBId',      alignment: HorizAlignment.Center},
            domainOptions: { maxLength: 256,  search: SalesAreaSearch, profileId: "default", searchCondition: {}}},

        ALL_SALES_AREAS:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Sales Area',   columnResourceName: 'colUsrGrpSalesArea',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
        USER_COUNT:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'No. of Users',   columnResourceName: 'colUsrGrpUsers',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
    }

const vWB_UserGroup_KeyFields =
    {id:    'WB_USRGRP_ID',
        id_ui: 'USRGRP_ID',
        name:  'USRGRP_NAME'}

class UserGroupSearchByListSearchProvider
    implements  ISearchProvider {

    arrWbUsrGrpIds: number[] = []
    wbUsrGrpMId: number = -1

    constructor(arrWbUsrGrpIds: number[], wbUsrGrpMId?: number){
        this.arrWbUsrGrpIds = arrWbUsrGrpIds
        this.wbUsrGrpMId = wbUsrGrpMId
    }

    get keyFields() { return vWB_UserGroup_KeyFields }

    get searchProviderFields(){
        return vUI_UserGroup_Search_Fields
    }

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {

        const self = this;
        return new Promise<any[]>((resolve, error) => {

            if (!searchOptions.where) {
                searchOptions.where = {};
            }

            if(_.isUndefined(searchOptions.where['WB_USRGRP_ID']))
                searchOptions.where.WB_USRGRP_ID = {nin : self.arrWbUsrGrpIds}

            if(self.wbUsrGrpMId > 0) {
                searchOptions.where.WB_USRGRPM_ID = self.wbUsrGrpMId
            }

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_UserGroup_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    let displayFields: string[] = <string[]>_.uniq(_.concat([
                        'USRGRP_ID','USRGRP_NAME', 'USRGRPM_NAME', 'MDSET_NAME','SALESORG_NAME', 'ALL_SALES_AREAS', 'USER_COUNT',
                    ], Object.values(this.keyFields)))
                    let returnVals: any[] = []
                    _.forEach(res, aRow => {
                        let aVal: { [id: string]: any } = {}
                        _.forEach(displayFields, aField => {
                            aVal[aField] = aRow[aField]
                        })
                        if (!_.filter(returnVals, aRow=>JSON.stringify(aVal)==JSON.stringify(aRow)).length) {
                            returnVals.push(aVal)
                        }
                    })
                    resolve(returnVals)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }
}


class UserGroupSearchByListSearchProfile
    implements  ISearchProfile {

    aSearchProvider: ISearchProvider = undefined

    profileId = "default"
    profileName = "Search by Id, Name"
    renderOptions = { ui5ResourceId: "UserGroupSearchProfileByName" }

    profileFilter: IProfileFilter[] = [
        {profileFilterName: 'User Group Id',     searchProviderFieldId: 'USRGRP_ID',   renderOptions: { }},
        {profileFilterName: 'User Group Name',   searchProviderFieldId: 'USRGRP_NAME', renderOptions: { }},
        {profileFilterName: 'User Group Type',  searchProviderFieldId: 'WB_USRGRPM_ID',    bMultiSelect: true, renderOptions: { }},
        {profileFilterName: 'Sales Area',  searchProviderFieldId: 'WB_SALESAREA_ID',    bMultiSelect: true, renderOptions: { }}
    ]

    profileDisplayFields = [
        'USRGRP_ID','USRGRP_NAME', 'USRGRPM_NAME', 'MDSET_NAME','SALESORG_NAME', 'ALL_SALES_AREAS', 'USER_COUNT',
    ]


    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault = ""    //string;
    profileSorts: []//ISearchSort[];


    constructor(wbUsrGrpIds: number[], wbUsrGrpMId? : number){
        this.aSearchProvider = new UserGroupSearchByListSearchProvider(wbUsrGrpIds, wbUsrGrpMId)
    }

    get profileSearchProvider(){ return this.aSearchProvider }

}


export class UserGroupSearchByList
    implements  ISearch {
    /**
     * @param wbUsrGrpIds WB_USRGRP_ID records that will be excluded from the results
     * @param wbUsrGrpMId WB_USRGRPM_ID - optional
     **/
    constructor(wbUsrGrpIds: number[], wbUsrGrpMId?: number, _options?: any){
        this.searchProfiles = [ new UserGroupSearchByListSearchProfile(wbUsrGrpIds, wbUsrGrpMId) ]
    }

    searchName = "Select User Group(s)"
    renderOptions = { ui5ResourceId: "UserGroupSearchByList"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[]
    autoSearch = true

}
